<template>
  <div class="bxTjzbhxr" v-if="kbxmlc">
    <div class="box noBtn">
      <div class="row">
        <div class="clear">
          <p class="cont-title lf">推荐中标候选人</p>
        </div>
        <div class="row">
          <el-button :disabled="isNext" type="primary" @click="draw"
            >抽取编号</el-button
          >
          <el-button type="primary" @click="handleRecord"
            >抽取记录</el-button
          >
        </div>
      </div>
      <div class="main">
        <!-- <div class="main-top">
          <div class="main-top-left">
            <label>推荐中标候选人方式</label>
            <el-select
              v-model="tjzbhxr"
              style="width: 250px"
              placeholder="请选择"
              @change="tjzbhxrChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value + 'option'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <table-tem
          ref="table"
          :config="tableConfig"
          :key="tableConfig.key"
          :span-method="objectSpanMethod"
          :highlightCurrentRow="false"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
          <template #tjzbhxr="scope">
            <el-checkbox
              v-if="kbxmlc.zt != '2'"
              v-model="scope.data.winningCandidate"
              @change="(data) => saveWinningCandidate(data, scope.data)"
              :true-label="1"
              :false-label="0"
              >中标候选人</el-checkbox
            >
            <template v-else>
              {{ scope.data.winningCandidate == 1 ? "中标候选人" : "" }}
            </template>
          </template>
        </table-tem>
        <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
      </div>
      <el-button
        v-if="role == 'Z'"
        :disabled="isNext || candidateState"
        @click="bxNextBtn"
        type="primary lcNext"
        >下一步</el-button
      >
    </div>

    <drawRecord 
      ref="recordDialog" 
      title="抽取记录"
      :djlcId="djlcId" 
      :kbxm="kbxm"
    />
  </div>

  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
  
  <script>
import tableTem from "@/components/tableTem/index.vue";
import drawRecord from "../components/drawRecord.vue";

export default {
  components: {
    tableTem, drawRecord
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
    isNext() {
      return this.kbxmlc.zt == 2;
    },
  },
  data() {
    return {
      waitLoading: false,
      djlcId: "", //节点流程id
      tbdwmc: "",
      kbxmlc: {},
      kbxm: {},
      tableConfig: {
        head: [],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        key: 1,
      },
      options: [
        {
          value: 1,
          label: "按投标单位自动推荐",
        },
        {
          value: 2,
          label: "按分项推荐",
        },
      ],
      tjzbhxr: null,
      tableData: [],
      number: [],
      candidate: null,
      candidateOptions: [],
      candidateState: true,
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.tjzbhxr = 1;
    this.$nextTick(() => {
      this.getData();
      this.getCandidateState();
    });
  },
  methods: {
    handleRecord() {
      this.$refs.recordDialog.show()
    },
    searchData() {
      let obj = {
        tbdwmc: this.tbdwmc,
      };
      this.getData(obj);
    },
    async saveWinningCandidate(data, row) {
      try {
        let para = {
          jgdm: row.entCode,
          zbzt: data,
        };
        this.waitLoading = true;
        let res = await this.$api.saveCandidate(para);
        if (res.data.success) {
          this.getData();
          this.getCandidateState();
        } else {
          this.$message({ type: "error", message: res.data.msg });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log("err", err);
        this.$message({ type: "error", message: err.data.msg });
        this.getData();
        this.getCandidateState();
      }
    },
    async getCandidateState() {
      try {
        let res = await this.$api.getCandidateState();
        if (res.status == 200) {
          this.candidateState = !res.data.data;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    draw() {
      window.open(
        `/tjzbhxrDraw?len=${this.tableData.length}&kbxmId=${this.kbxm.id}&lcId=${this.djlcId}`,
        "_blank"
      );
    },
    changeData(secondaryName, threeLevelName) {
      this.tableConfig.data = [];
      this.number = [];
      this.companyFlag = false;
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          k[threeLevelName].map((p, index) => {
            k[p.bjcsId] = p.csznr;
          });
        });
      }
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          let param = {
            ...v,
            qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
            qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
            ...k,
          };
          this.tableConfig.data.push(param);
        });
      }
      for (let i = 0; i < this.tableData.length; i++) {
        this.number.push({
          qdmc: this.tableData[i].qdmc,
          num: this.tableData[i][secondaryName].length,
        });
      }
      let msgIndex = 0;
      let msgArr = [];
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        msgIndex += num;
        msgArr.push(msgIndex);
      }
      msgArr.pop();
      msgArr.unshift(0);
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        this.tableConfig.data[msgArr[i]].rowspan = num;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 如果是前两列，就使用idIndex数据来进行合并
      if (this.tjzbhxr == 1) {
        console.log(row, column, columnIndex);
        if (
          [0, 1, 2, 9, 10, 11].includes(columnIndex) ||
          column.label == "推荐中标候选人" ||
          column.label == "排序"
        ) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      } else {
        if (columnIndex <= 2) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
    },
    tjzbhxrChange(index) {
      this.tjzbhxr = index;
      this.$refs.table.$refs.tableTem.clearSelection();
      this.getData();
    },
    getData(data) {
      this.once();
      this.$refs.table.$refs.tableTem.clearSelection();
      this.candidate = null;
      let para = {
        djlcId: this.djlcId,
        currentPage: this.tableConfig.currentPage,
        type: this.tjzbhxr,
        pageSize: this.tableConfig.pageSize,
      };
      para = Object.assign(para, data);
      this.waitLoading = true;
      this.$api
        .xbzbhxrList(para)
        .then((res) => {
          if (res.data.meta.success) {
            let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
            cgTbbjCsList.map((item, index) => {
              this.tableConfig.head.splice(3 + index, 0, {
                key: item.id,
                title:
                  item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
                align: "center",
              });
            });
            this.tableData = res.data.data.tbdwList.list;
            this.tableConfig.total = res.data.data.tbdwList.total;
            this.kbxm = res.data.data.kbxm;
            this.kbxmlc = res.data.data.kbxmlc;
            this.tableConfig.key++;
            if (this.tjzbhxr == 1) {
              this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
            } else {
              this.changeData("tbdwTmResultList", "tbdwCsTmResultList");
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    once() {
      this.tableConfig.head = [
        {
          type: "selection",
          width: 40,
        },
        {
          key: "xh",
          title: "序号",
          align: "center",
          width: 60,
        },
        {
          key: "qymc",
          title: "投标单位名称",
          align: "center",
        },
        // {
        // key: "pm",
        // title: "排序",
        // align: "center",
        // },
        {
          type: "slot",
          title: "推荐中标候选人",
          align: "center",
          slotName: "tjzbhxr",
        },
      ];
    },
    bxNextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>
  
  <style lang='scss' scoped>
.noBtn {
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
  .main-top {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .main-top-left {
      margin-bottom: 10px;
      label {
        margin-right: 20px;
      }
    }
  }
  .rightButton {
    position: absolute;
    right: 10px;
    top: 60px;
  }
}
.clear {
  clear: initial !important;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pageNum {
  position: relative;
  bottom: 50px;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: white;
}
</style>
  